import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { getSuiteLegalDisclaimerUrl } from 'pricing-pages-lib/utils/urls';
import { useSelector } from 'react-redux';
import { isHSFXEligibleSelector } from '../../selectors/PromotionSelectors';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmSuiteAlert = ({
  suiteProductLevel
}) => {
  const isHSFXEligible = useSelector(isHSFXEligibleSelector);
  if (isHSFXEligible || !suiteProductLevel) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    type: "info",
    marginBlockStart: "400",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `planBuilder.crmSuiteAlert.${suiteProductLevel}_jsx`,
      elements: {
        UILink: Link
      },
      options: {
        link: getSuiteLegalDisclaimerUrl(),
        onClick: () => {
          trackClickedLink({
            name: 'legal-stuff',
            value: 'See terms',
            type: 'external',
            url: getSuiteLegalDisclaimerUrl()
          });
        }
      }
    })
  });
};
export default CrmSuiteAlert;